import React from 'react';
import { ComponentProps } from './Tab.types';
import StyledTab from './Tab.styled';

const Tab: React.FC<ComponentProps> = ({
  mode,
  tabWidthPerc,
  label,
  onTabChange,
  isActive,
  isDisabled,
  scrollable = false,
}) => {
  return (
    <StyledTab
      type="button"
      onClick={onTabChange}
      pb={2}
      state={isActive ? 'active' : 'normal'}
      mode={mode}
      disabled={isDisabled}
      tabWidthPerc={tabWidthPerc}
      scrollable={scrollable}>
      {label}
    </StyledTab>
  );
};

export default Tab;
